import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {SettingsPassOnLogService} from '../../services/settings-pass-on-log.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'settings-pass-on-log.component.html'
})
export class SettingsPassOnLogComponent implements OnInit, OnDestroy {

    constructor(public settingsPassOnLogService: SettingsPassOnLogService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.settingsPassOnLogService.getUserRoles();
        this.urlService.onUrlChange
            .pipe(
                tap(
                    () => {
                        this.settingsPassOnLogService.showDetailedView = false;
                        this.settingsPassOnLogService.selectedItemData = null;
                    }
                ),
                flatMap(
                    () => this.settingsPassOnLogService.getCorporationsByQueryParams(true)
                        .pipe(
                            takeUntil(this.urlService.instantOnUrlChange)
                        )
                )
            )
            .subscribe();
        this.urlService.setQueryParams('allSettingsPassOnLog');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.settingsPassOnLogService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.settingsPassOnLogService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/settings-pass-on-log/settings-pass-on-log.component.ts